import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterContainerTitle = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-container-v2-title", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterContainerTitle;
